import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { useAppState, useAppDispatch } from 'context';
import { setPlayerView } from 'context/actions';
import { ReactComponent as MobileViewIcon } from 'assets/mobile-view.svg';
import './MobileIcon.scss';

const MobileIcon = () => {
  const dispatch = useAppDispatch();
  const { mobileView } = useAppState();

  const handleClick = () => dispatch(setPlayerView({ webView: false, mobileView: !mobileView }));

  return (
    <Tooltip title='Mobile Layout'>
      <Button type='primary' 
        shape='circle' 
        className='app-icon-container' 
        onClick={handleClick} 
      >
        <MobileViewIcon fill={mobileView ? '#F1C3DB' : '#999b9e'} />
      </Button>
    </Tooltip>
  );
}

export default MobileIcon;
